let _authorize = null;
//Keys
const INVITATION_TYPE = "INVITATION_TYPE";
const INVITATION_USED_EMAIL = "INVITATION_USED_EMAIL";
const INVITATION_CONTENT = "INVITATION_CONTENT";

//values
const INVITATION_TYPE_NEW_CRO = "INVITATION_TYPE_NEW_CRO";
const INVITATION_TYPE_NEW_USER = "INVITATION_TYPE_NEW_USER";
const INVITATION_TYPE_JOIN_STUDY_INVESTIGATOR =
  "INVITATION_TYPE_JOIN_STUDY_INVESTIGATOR";
const INVITATION_TYPE_JOIN_STUDY_PATIENT = "INVITATION_TYPE_JOIN_STUDY_PATIENT";
const INVITATION_TYPE_JOIN_CRO = "INVITATION_TYPE_JOIN_CRO";

const keys = {
  //Keys
  INVITATION_TYPE,
  INVITATION_USED_EMAIL,
  INVITATION_CONTENT,
};

const consts = {
  //const values
  INVITATION_TYPE_NEW_CRO,
  INVITATION_TYPE_NEW_USER,
  INVITATION_TYPE_JOIN_STUDY_INVESTIGATOR,
  INVITATION_TYPE_JOIN_STUDY_PATIENT,
  INVITATION_TYPE_JOIN_CRO,
};

const init = ({ authorize }) => {
  !_authorize && (_authorize = authorize);
};

const STATE = {
  [INVITATION_TYPE]: null,
  [INVITATION_USED_EMAIL]: null,  
  [INVITATION_CONTENT]: null,
};

const reloadState = (authorize) => {
  if (authorize !== _authorize) {
    return {
      success: false,
      message: "Unauthorized",
      fromError: null,
      errorCode: "unauthorized-error",
      errorKey: 305464,
    };
  }
  return STATE;
};

const setValue = (authorize, keyName, value) => {
  if (authorize !== _authorize) {
    return {
      success: false,
      message: "Unauthorized",
      fromError: null,
      errorCode: "unauthorized-error",
      errorKey: 655691,
    };
  }
  STATE[keyName] = value;
};

const reset = (authorize) => {
  if (authorize !== _authorize) {
    return {
      success: false,
      message: "Unauthorized",
      fromError: null,
      errorCode: "unauthorized-error",
      errorKey: 948376,
    };
  }
  STATE[INVITATION_TYPE] = null;
  STATE[INVITATION_USED_EMAIL] = null;
  STATE[INVITATION_CONTENT] = null;
};

const InvitationState = {
  //Keys
  KEYS: { ...keys },
  ...keys,

  //Values
  CONSTS: { ...consts },
  ...consts,

  init,
  reset,
  reloadState,
  setValue,
};

export default InvitationState;

export {
  keys as KEYS,
  consts as CONSTS,
  INVITATION_TYPE,
  INVITATION_USED_EMAIL,
  INVITATION_CONTENT,
  INVITATION_TYPE_NEW_CRO,
  INVITATION_TYPE_NEW_USER,
  INVITATION_TYPE_JOIN_STUDY_INVESTIGATOR,
  INVITATION_TYPE_JOIN_STUDY_PATIENT,
  INVITATION_TYPE_JOIN_CRO,
};
